import {Text} from '@primer/react-brand'
import {clsx} from 'clsx'

import Styles from './Label.module.css'

type Props = {
  text: string
  hideIcon?: boolean
  className?: string
}

export function Label(props: Props) {
  const {text, hideIcon, className} = props

  return (
    <Text className={clsx(Styles.Label, className)} as="div">
      {text}
      {!hideIcon && <span className={Styles.Icon} />}
    </Text>
  )
}

try{ Label.displayName ||= 'Label' } catch {}